import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import ExpansionPanel from '@/views/components/ExpansionPanel.vue';
import { mdiFilterVariant, mdiPrinter } from '@mdi/js';
import FiltroOrdenacao from '@/views/components/FiltroOrdenacao.vue';
import CardResultado from './CardResultado.vue';
import { ConsultaParecerStore } from '@/views/parecer/store/ConsultaParecerStore';
import { storeToRefs } from 'pinia';
import {
  contemNaLista,
  isTodosSelecionados,
  selecionarTodos,
  toggleSelecionado,
} from '@/utils/ListUtils';
import AlertCard from '@/views/components/AlertCard.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResultadoConsulta',
  setup(__props) {

const store = ConsultaParecerStore();

const {
  pageSubfiltros,
  pareceres,
  pareceresSelecionados,
  totalElementos,
  dataOptions,
  totalHits,
  filtroParecer,
} = storeToRefs(store);

const { atualizarPaginacao, atualizarOrdenacao, consultaListaParecer } = store;

const resultadoConsulta = ref();

const ordenacaoSelecionada = computed(() => {
  return ordenacaoItems.value?.find(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (el: any) => el.value == filtroParecer.value.ordenacao
  );
});

const limparFiltrosResultado = () => {
  pageSubfiltros.value?.forEach((filtro) =>
    filtro?.valoresSubFiltroResponseDTO?.forEach(
      (subFiltro) => (subFiltro.checked = false)
    )
  );
};

const ordenacaoItems = computed(() => {
  return store.pageParecer.ordenacoes?.map((item) => ({
    text: item.label,
    value: item.value,
  }));
});

return { __sfc: true,store, pageSubfiltros, pareceres, pareceresSelecionados, totalElementos, dataOptions, totalHits, filtroParecer, atualizarPaginacao, atualizarOrdenacao, consultaListaParecer, resultadoConsulta, ordenacaoSelecionada, limparFiltrosResultado, ordenacaoItems, ExpansionPanel, mdiFilterVariant, mdiPrinter, FiltroOrdenacao, CardResultado, contemNaLista, isTodosSelecionados, selecionarTodos, toggleSelecionado, AlertCard }
}

})